'use strict';

angular.module('amexReconciliationApp')
  .service('TransactionPaginationService', function ($rootScope,
                                                     TransactionSortModel,
                                                     UserModel,
                                                     $window,
                                                     PaginationModelFactory) {
    var self = this;
    var PAGE_NAME = 'TransactionList';
    var PAGE_SIZE = getPageSize();
    var transactionPaginationModel = PaginationModelFactory.create(PAGE_SIZE);

    self.pageSize = transactionPaginationModel.pageSize;
    self.pageStart = transactionPaginationModel.pageStart;
    self.pageEnd = transactionPaginationModel.pageEnd;
    self.totalCount = transactionPaginationModel.totalCount;
    self.pageNumber = transactionPaginationModel.pageNumber;
    self.recordsOnCurrentPage = transactionPaginationModel.recordsOnCurrentPage;
    self.nextPage = transactionPaginationModel.nextPage;
    self.previousPage = transactionPaginationModel.previousPage;
    self.updateCurrentPage = transactionPaginationModel.updateCurrentPage;
    self.repaginate = transactionPaginationModel.repaginate;

    self.updatePreferences = function (pageSize) {
      _.set(UserModel.currentUserPreferences().paginationSettings, PAGE_NAME, pageSize);
      UserModel.updatePreferences();
    };

    function resetPageSize() {
      transactionPaginationModel.pageSize(getPageSize());
    }

    function getPageSize() {
      return $window.PAGE_SIZE || _.get(UserModel.currentUserPreferences().paginationSettings, PAGE_NAME, 100);
    }

    TransactionSortModel.onTransactionsChanged($rootScope, self.repaginate, null, true);
    UserModel.onCurrentUserChanged($rootScope, resetPageSize);

  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/services/TransactionPaginationService.js
// module id = 651
// module chunks = 0